module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/babel-runtime/6.18.0/babel-runtime/core-js/number/is-integer.js
// module id = 282
// module chunks = 0